var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadRequest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 566.93",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.05;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#d1d1d1;}.cls-5,.cls-6,.cls-7{fill:#fff;}.cls-6{opacity:0.6;}.cls-7{opacity:0.7;}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:#e2a88a;}.cls-10{fill:gray;}.cls-11{fill:#73be00;}.cls-12{fill:#d30041;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 283.46,
    cy: 283.46,
    r: 282.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "589.76 486.19 85.72 608.02 37.39 148.86 482.24 41.34 589.76 486.19"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.46,
    cy: 283.46,
    r: 283.46
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 84.04,
    y: 139.33,
    width: 597.12,
    height: 454.61,
    rx: 16.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 103.15,
    y: 214.75,
    width: 1428.69,
    height: 99.03,
    rx: 16.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 103.15,
    y: 335.75,
    width: 585.48,
    height: 280.31,
    rx: 6.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 272.26,
    y: 174.83,
    width: 187.01,
    height: 187.01,
    rx: 52.63
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.13,377.1c-8.56-3.81-21.95-4.53-29.28-2.47s-34,5.19-38.17,8.63-48.53,47.86-58,57.84,22.13,14.7,22.13,14.7l69.42-27.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M252.66,422.34l9,7.33a3.44,3.44,0,0,0,4.86-.46L322,361.5l-14.34-11.74-55.5,67.69a3.46,3.46,0,0,0,.51,4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.37,245.54l10.14,2.4a91.28,91.28,0,0,0,3.43,52.51,93.08,93.08,0,0,0,65.83,58.2,91.59,91.59,0,0,0,93.9-33.07,91.53,91.53,0,0,0,13-87.54,93,93,0,0,0-65.83-58.19A91.56,91.56,0,0,0,292,212.92a90.68,90.68,0,0,0-16.47,35l-10.14-2.41-10.15-2.41A111.25,111.25,0,0,1,326,163.27a112.63,112.63,0,0,1,64.52-3.62A114.13,114.13,0,0,1,471.21,231a112.08,112.08,0,0,1,4.2,64.39,111.19,111.19,0,0,1-70.76,79.86,112.62,112.62,0,0,1-64.52,3.62,114.15,114.15,0,0,1-80.69-71.33,112.16,112.16,0,0,1-4.22-64.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M270.22,404.77s8.39-2.39,11.94-5.42,25.93-26.41,35.44-13.14-19.82,28.47-19.82,28.47-18,15.35-21.18,19.22-14.47,22.22-26.35,24.49-21.3-3.87-34.19,5.39l-16.69-35.31s53.68-49.83,70.85-23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M259.08,438.74c-6.14,4.05-31.58,28.89-44.57,53.27-11.87-10.42-38-32.55-38-32.55s26.77-30.81,38.4-41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M89.94,529.08c21.52-22.24,95.82-98.26,95.82-98.26l54,41.5-91.6,101.54C127.7,562.21,106,546.5,89.94,529.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.75,
    y: 88.69,
    width: 457.66,
    height: 457.66,
    transform: "translate(-65.82 82.56) rotate(-13.59)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.56,286a21.28,21.28,0,0,1-6.9-1,13.14,13.14,0,0,1-5-3,12.67,12.67,0,0,1-3.06-5,21.7,21.7,0,0,1-1-7V250.64a3.45,3.45,0,1,1,6.88,0v19.23q0,5.1,2.33,7.65t6.8,2.55q4.45,0,6.77-2.55t2.31-7.65V250.64a3.07,3.07,0,0,1,3.44-3.5,3.48,3.48,0,0,1,2.5.86,3.54,3.54,0,0,1,.88,2.64v19.28a19.64,19.64,0,0,1-1.8,8.86,11.83,11.83,0,0,1-5.34,5.4A19.26,19.26,0,0,1,140.56,286Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M167.9,285.88a3.36,3.36,0,0,1-2.55-.94,3.67,3.67,0,0,1-.89-2.61V251.07a3.47,3.47,0,0,1,.92-2.61,3.56,3.56,0,0,1,2.58-.89H180.9q6.24,0,9.62,3t3.38,8.36a11.35,11.35,0,0,1-1.53,6,9.82,9.82,0,0,1-4.43,3.87,16.59,16.59,0,0,1-7,1.35l.49-.81h1.77A6.88,6.88,0,0,1,187,270.4a9,9,0,0,1,2.87,3.39l4,7.47a4,4,0,0,1,.59,2.2,2.37,2.37,0,0,1-.8,1.74,3.2,3.2,0,0,1-2.2.68,4.17,4.17,0,0,1-2.37-.62,5.19,5.19,0,0,1-1.61-1.91l-5.43-10a5.27,5.27,0,0,0-2.28-2.45,8,8,0,0,0-3.36-.61h-5.1v12a3.75,3.75,0,0,1-.86,2.61A3.34,3.34,0,0,1,167.9,285.88Zm3.44-20.69h8.38a8.81,8.81,0,0,0,5.61-1.53,5.51,5.51,0,0,0,1.91-4.59,5.45,5.45,0,0,0-1.91-4.54,8.81,8.81,0,0,0-5.61-1.53h-8.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M204.81,285.45a3.46,3.46,0,0,1-2.58-.94,3.59,3.59,0,0,1-.91-2.61v-31a3.53,3.53,0,0,1,.88-2.6,3.45,3.45,0,0,1,2.55-.89,3.1,3.1,0,0,1,3.44,3.49v28.69h15.58a3.08,3.08,0,0,1,2.23.75,2.85,2.85,0,0,1,.78,2.15,3,3,0,0,1-.78,2.18,3,3,0,0,1-2.23.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M234.24,266.86a3.82,3.82,0,0,1-4-4,3.85,3.85,0,0,1,1.1-2.87,4,4,0,0,1,2.92-1.1,3.86,3.86,0,0,1,2.93,1.1,4.42,4.42,0,0,1,0,5.72A3.8,3.8,0,0,1,234.24,266.86Zm0,18.85a3.9,3.9,0,0,1-2.92-1.12,4,4,0,0,1-1.1-2.9,3.82,3.82,0,0,1,1.1-2.83,4,4,0,0,1,2.92-1.1,3.86,3.86,0,0,1,2.93,1.1,4,4,0,0,1,1.05,2.83,4.1,4.1,0,0,1-1.05,2.9A3.8,3.8,0,0,1,234.24,285.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.48,290.07a3.53,3.53,0,0,1-2.37-.78,3,3,0,0,1-1.07-2,3.33,3.33,0,0,1,.78-2.4L304,267.32v3.17l-12.58-16.86a3.55,3.55,0,0,1-.81-2.45,2.85,2.85,0,0,1,1-2,3.44,3.44,0,0,1,2.31-.78,3.9,3.9,0,0,1,2.05.55,6.92,6.92,0,0,1,1.82,1.82l10.39,14.32h-2.37l10.34-14.32a6.78,6.78,0,0,1,1.82-1.82,4,4,0,0,1,2.11-.55,3.61,3.61,0,0,1,2.36.75,2.76,2.76,0,0,1,1.05,1.94,3.72,3.72,0,0,1-.87,2.51l-12.59,16.86v-3.17l13.17,17.61a3.4,3.4,0,0,1,.8,2.4,2.82,2.82,0,0,1-1,2,3.65,3.65,0,0,1-2.43.78,3.54,3.54,0,0,1-2-.58,7.71,7.71,0,0,1-1.88-1.85l-11-15h2.54l-10.92,15a6.85,6.85,0,0,1-1.84,1.85A3.81,3.81,0,0,1,293.48,290.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M332.28,290.07a3.52,3.52,0,0,1-2.36-.78,2.91,2.91,0,0,1-1.07-2,3.24,3.24,0,0,1,.78-2.4l13.22-17.61v3.17l-12.59-16.86a3.65,3.65,0,0,1-.81-2.45,2.89,2.89,0,0,1,1-2,3.47,3.47,0,0,1,2.31-.78,3.88,3.88,0,0,1,2.05.55,6.64,6.64,0,0,1,1.82,1.82l10.4,14.32H344.7L355,250.8a6.64,6.64,0,0,1,1.82-1.82,4,4,0,0,1,2.1-.55,3.62,3.62,0,0,1,2.37.75,2.75,2.75,0,0,1,1,1.94,3.62,3.62,0,0,1-.87,2.51l-12.59,16.86v-3.17l13.17,17.61a3.36,3.36,0,0,1,.81,2.4,2.83,2.83,0,0,1-1,2,3.64,3.64,0,0,1-2.43.78,3.56,3.56,0,0,1-2-.58,7.87,7.87,0,0,1-1.87-1.85l-11-15h2.55l-10.92,15a6.87,6.87,0,0,1-1.85,1.85A3.79,3.79,0,0,1,332.28,290.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M371.09,290.07a3.56,3.56,0,0,1-2.37-.78,3,3,0,0,1-1.07-2,3.33,3.33,0,0,1,.78-2.4l13.23-17.61v3.17l-12.59-16.86a3.55,3.55,0,0,1-.81-2.45,2.85,2.85,0,0,1,1-2,3.45,3.45,0,0,1,2.31-.78,3.9,3.9,0,0,1,2.05.55,6.78,6.78,0,0,1,1.82,1.82l10.39,14.32h-2.36l10.33-14.32a6.78,6.78,0,0,1,1.82-1.82,4,4,0,0,1,2.11-.55,3.66,3.66,0,0,1,2.37.75,2.79,2.79,0,0,1,1,1.94,3.67,3.67,0,0,1-.87,2.51l-12.59,16.86v-3.17l13.17,17.61a3.46,3.46,0,0,1,.81,2.4,2.87,2.87,0,0,1-1,2,3.65,3.65,0,0,1-2.43.78,3.56,3.56,0,0,1-2-.58,7.88,7.88,0,0,1-1.88-1.85l-11-15h2.54l-10.91,15a6.87,6.87,0,0,1-1.85,1.85A3.81,3.81,0,0,1,371.09,290.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M409.9,290.07a3.53,3.53,0,0,1-2.37-.78,3,3,0,0,1-1.07-2,3.24,3.24,0,0,1,.78-2.4l13.23-17.61v3.17l-12.6-16.86a3.59,3.59,0,0,1-.8-2.45,2.82,2.82,0,0,1,1-2,3.44,3.44,0,0,1,2.31-.78,3.93,3.93,0,0,1,2.05.55,6.92,6.92,0,0,1,1.82,1.82l10.39,14.32h-2.37l10.34-14.32a6.78,6.78,0,0,1,1.82-1.82,4,4,0,0,1,2.11-.55,3.61,3.61,0,0,1,2.36.75,2.71,2.71,0,0,1,1,1.94,3.66,3.66,0,0,1-.86,2.51l-12.59,16.86v-3.17l13.16,17.61a3.36,3.36,0,0,1,.81,2.4,2.79,2.79,0,0,1-1,2,3.61,3.61,0,0,1-2.42.78,3.54,3.54,0,0,1-2-.58,7.71,7.71,0,0,1-1.88-1.85l-11-15h2.54l-10.92,15a6.73,6.73,0,0,1-1.85,1.85A3.76,3.76,0,0,1,409.9,290.07Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bad-request.3b139fe61a02b084340474dbe5b7d146.svg";